/**
 * viewing-data-total-identified-viewing-summary
 *
 * @author    Andrew Fisher <andrew.fisher@mediatel.co.uk>
 * @copyright 2021 Mediatel Limited.
 */

"use strict";

import "babel-polyfill";
import coreFactory from "./common/core";
import sandboxFactory from "./common/sandbox";

// Modules:
import totalIdentifiedViewingWaterfallChart from "./viewing-data/total-identified-viewing-summary-waterfall-chart";

const core = coreFactory(window.jQuery, sandboxFactory);

core.createModule(
    "totalIdentifiedWaterfallChart",
    totalIdentifiedViewingWaterfallChart('viewing-report/tiv-monthly-summary/data')
);

core.startAll();
